<template>
  <v-layout align-start>
    <v-flex>
      <v-app-bar>
        <v-toolbar-title class="font-weight-black primary--text"
          >Servicio</v-toolbar-title
        >
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              @click="mostrarCarga"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> file_upload </v-icon>
            </v-btn>
          </template>
          <span>Carga masiva de datos</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              @click="addItem"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> add </v-icon>
            </v-btn>
          </template>
          <span>Ingresar nuevo registro</span>
        </v-tooltip>
      </v-app-bar>
      <v-data-table
        dense
        :headers="headers"
        :items="servicios"
        :items-per-page="2"
        :search="search"
        sort-by="codigo"
        class="elevation-1"
        :header-props="{ 'sort-icon': 'fa-solid fa-arrow-down-wide-short' }"
        :footer-props="{
          showFirstLastPage: true,
          'items-per-page-text': 'Filas por página',
          'items-per-page-options': [50, 100, 150, -1],
        }"
      >
        <template v-slot:[`item.opciones`]="{ item }">
          <v-btn x-small text dark color="primary" @click="editItem(item)">
            <v-icon x-small>edit</v-icon>
          </v-btn>
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <div v-if="item.estado == 'A'">
            <v-btn color="success" x-small text dark @click="desactivar(item)">
              <v-icon x-small>check</v-icon>
            </v-btn>
          </div>
          <div v-else>
            <v-btn color="error" x-small text dark @click="activar(item)">
              <v-icon x-small>block</v-icon>
            </v-btn>
          </div>
        </template>

        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title class="font-weight-black primary--text">
            </v-toolbar-title>
            <v-text-field
              outlined
              dense
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Búsqueda General"
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-text-field
              outlined
              dense
              class="text-xs-center"
              v-model="searchCodigoValue"
              append-icon="search"
              label="Búsqueda por código"
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-text-field
              outlined
              dense
              class="text-xs-center"
              v-model="searchDescripcionValue"
              append-icon="search"
              label="Búsqueda por descripción"
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>

            <v-dialog v-model="dialog" max-width="500px">
              <v-card ref="form">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          dense
                          ref="codigo"
                          v-model="codigo"
                          :readonly="!editCodigo"
                          :rules="[$rules.requerido, $rules.max50, $rules.min2]"
                          :error-messages="errorMessages"
                          label="Código"
                          placeholder="Código"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          dense
                          ref="descripcion"
                          v-model="descripcion"
                          :rules="[$rules.requerido, $rules.max100, $rules.min2]"
                          :error-messages="errorMessages"
                          label="Descripción"
                          placeholder="Descripción"
                          required
                        ></v-text-field>

                        <v-autocomplete
                          outlined
                          dense
                          ref="id_nit"
                          v-model="id_nit"
                          :items="nits"
                          :rules="[$rules.requerido]"
                          label="Nit Facturación"
                          item-text="descripcion"
                          item-value="id"
                        ></v-autocomplete>
                        <v-btn value="Agregar Nit" @click="activarDialogNit()">
                          <span>Agregar Nit</span>
                          <v-icon color="green"> add_circle_outline </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">Cancelar</v-btn>
                  <v-btn color="primary" text @click="guardar">Guardar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="listar">Reset</v-btn>
        </template>
      </v-data-table>

      <v-dialog v-model="dialogUpload" max-width="50%">
        <v-card>
          <v-card-title>
            <span class="headline">Carga Masiva de Datos</span>
          </v-card-title>
          <v-card-text>
            <v-file-input
              dense
              id="file"
              ref="file"
              v-model="file"
              @change="archivoCambiado"
              show-size
              chips
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              prepend-icon="cancel_presentation"
              placeholder="Seleccione un archivo Excel"
            >
              <template v-slot:selection="{ text }">
                <v-chip color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-spacer></v-spacer>
            <div v-show="mostrarErrores">
              <v-textarea
                outlined
                dense
                ref="error"
                v-model="error"
                :rules="[]"
                :readonly="true"
                :error-messages="errorMessages"
                label="Lista de Errores"
                placeholder="Lista de Errores"
                required
              ></v-textarea>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeUpload">Cancelar</v-btn>
            <v-btn color="primary" text @click="guardarExcel">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogNit" max-width="500px">
                  <v-card ref="form">
                    <v-card-title>
                      <span class="headline">Agregar Nit</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              outlined
                              dense
                              ref="codigoNit"
                              v-model="codigoNit"
                              :rules="[
                                $rules.requerido,
                                $rules.min2,
                                $rules.max25,
                              ]"
                              :error-messages="errorMessagesNit"
                              label="Nit"
                              placeholder="Nit"
                              required
                            ></v-text-field>
                          </v-col>

                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              outlined
                              dense
                              ref="descripcionNit"
                              v-model="descripcionNit"
                              :rules="[
                                $rules.requerido,
                                $rules.min2,
                                $rules.max100,
                              ]"
                              :error-messages="errorMessagesNit"
                              label="Razón Social"
                              placeholder="Razón Social"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field
                              outlined
                              dense
                              ref="notasNit"
                              v-model="notasNit"
                              :rules="[]"
                              :error-messages="errorMessagesNit"
                              label="Notas"
                              placeholder="Notas"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              outlined
                              dense
                              ref="primer_nombreNit"
                              v-model="primer_nombreNit"
                              :rules="[]"
                              :error-messages="errorMessagesNit"
                              label="Primer Nombre"
                              placeholder="Primer Nombre"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              outlined
                              dense
                              ref="segundo_nombreNit"
                              v-model="segundo_nombreNit"
                              :rules="[]"
                              :error-messages="errorMessagesNit"
                              label="Segundo Nombre"
                              placeholder="Segundo Nombre"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              outlined
                              dense
                              ref="primer_apellidoNit"
                              v-model="primer_apellidoNit"
                              :rules="[]"
                              :error-messages="errorMessagesNit"
                              label="Primer Apellido"
                              placeholder="Primer Apellido"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              outlined
                              dense
                              ref="segundo_apellidoNit"
                              v-model="segundo_apellidoNit"
                              :rules="[]"
                              :error-messages="errorMessagesNit"
                              label="Segundo Apellido"
                              placeholder="Segundo Apellido"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              outlined
                              dense
                              ref="direccionNit"
                              v-model="direccionNit"
                              :rules="[]"
                              :error-messages="errorMessagesNit"
                              label="Dirección"
                              placeholder="Dirección"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              outlined
                              dense
                              ref="correoNit"
                              v-model="correoNit"
                              :rules="[]"
                              :error-messages="errorMessagesNit"
                              label="Correo"
                              placeholder="Correo"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              outlined
                              dense
                              ref="telefonoNit"
                              v-model="telefonoNit"
                              :rules="[]"
                              :error-messages="errorMessagesNit"
                              label="Teléfono"
                              placeholder="Teléfono"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              outlined
                              dense
                              ref="celularNit"
                              v-model="celularNit"
                              :rules="[]"
                              :error-messages="errorMessagesNit"
                              label="Celular"
                              placeholder="Celular"
                              required
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="closeNit"
                        >Cancelar</v-btn
                      >
                      <v-btn color="primary" text @click="guardarNit"
                        >Guardar</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      servicios: [],
      nits: [],
      dialog: false,
      dialogNit:false,
      dialogUpload: false,
      usuario: this.$store.state.usuario.user,

      codigoNit: "",
      descripcionNit: "",
      notasNit: "",
      primer_nombreNit: "",
      segundo_nombreNit: "",
      primer_apellidoNit: "",
      segundo_apellidoNit: "",
      direccionNit: "",
      correoNit: "",
      telefonoNit: "",
      celularNit: "",
      porcentaje: 0,

      errorMessagesNit: "",

      page: 1,
      itemsPerPage: 12,
      headers: [
        {
          text: "Opciones",
          value: "opciones",
          sortable: false,
          width: "10%",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Código",
          value: "codigo",
          align: "left",
          filter: this.filtroCodigo,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Descripción",
          value: "descripcion",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },

        {
          text: "Activo",
          value: "estado",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
      ],

      rules: {
        requerido: (value) => !!value || "Debe llenar este campo.",
        numero: (value) => {
          const pattern = /^\d*\.?\d*$/;
          return pattern.test(value) || "Ingrese un número válido.";
        },
        GestionMin: (value) => value >= 1950 || "Ingrese una gestión superior.",
        GestionMax: (value) => value <= 2200 || "Ingrese una gestión inferior.",
        min2: (value) =>
          value.length >= 2 || "El campo tiene que tener mas de 2 caracteres.",
        min5: (value) =>
          value.length >= 5 || "El campo tiene que tener mas de 5 caracteres.",
        max10: (value) =>
          value.length <= 10 || "El campo debe tener menos de 10 caracteres.",
        max25: (value) =>
          value.length <= 25 || "El campo debe tener menos de 25 caracteres.",
        max30: (value) =>
          value.length <= 30 || "El campo debe tener menos de 30 caracteres.",
        max45: (value) =>
          value.length <= 45 || "El campo debe tener menos de 45 caracteres.",
        max50: (value) =>
          value.length <= 50 || "El campo debe tener menos de 50 caracteres.",
        max100: (value) =>
          value.length <= 100 || "El campo debe tener menos de 100 caracteres.",
        email: (value) => {
          const pattern = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})*$/;
          return pattern.test(value) || "Ingrese un email válido.";
        },
      },

      search: "",
      searchCodigoValue: "",
      searchDescripcionValue: "",

      desserts: [],
      editedIndex: -1,
      editCodigo: false,
      mostrarErrores: false,

      descripcionNit: "",
      notasNit: "",
      primer_nombreNit: "",
      segundo_nombreNit: "",
      primer_apellidoNit: "",
      segundo_apellidoNit: "",
      direccionNit: "",
      correoNit: "",
      telefonoNit: "",
      celularNit: "",

      id: "",
      codigo: "",
      descripcion: "",
      id_nit: "",
      file: null,

      valida: 0,

      validaMensaje: [],

      adCodigo: "",
      errorMessages: "",
      error: "",
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Registro" : "Actualizar Registro";
    },

    form() {
      return {
        codigo: this.codigo,
        descripcion: this.descripcion,
        id_nit: this.id_nit,
      };
    },

    formNit() {
      return {
        codigoNit: this.codigoNit,
        descripcionNit: this.descripcionNit,
        notasNit: this.notasNit,
        primer_nombreNit: this.primer_nombreNit,
        segundo_nombreNit: this.segundo_nombreNit,
        primer_apellidoNit: this.primer_apellidoNit,
        segundo_apellidoNit: this.segundo_apellidoNit,
        direccionNit: this.direccionNit,
        correoNit: this.correoNit,
        telefonoNit: this.telefonoNit,
        celularNit: this.celularNit,
      };
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    name() {
      this.errorMessages = "";
    },
  },

  created() {
    this.listar();
    this.selectNits();
  },

  methods: {
    archivoCambiado(e) {
      this.selectedFile = e;
    },

    closeUpload() {
      this.dialogUpload = false;
      this.limpiarUpload();
    },

    closeNit() {
      this.dialogNit = false;
      this.limpiarNit();
    },

    limpiarNit() {
      this.codigoNit = "";
      this.descripcionNit = "";
      this.notasNit = "";
      this.primer_nombreNit = "";
      this.segundo_nombreNit = "";
      this.primer_apellidoNit = "";
      this.segundo_apellidoNit = "";
      this.direccionNit = "";
      this.correoNit = "";
      this.telefonoNit = "";
      this.celularNit = "";
      this.validaMensajeNit = [];
    },

    guardarExcel() {
      let me = this;
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);
        axios
          .put("api/servicios/cargarExcel", formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.closeUpload();
            me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    listar() {
      let me = this;
      axios
        .get("api/servicios/listar")
        .then(function (response) {
          me.servicios = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    mostrarCarga() {
      this.dialogUpload = true;
    },

    activarDialogNit() {
      this.dialogNit = true;
    },

    editItem(item) {
      this.id = item.id;
      this.codigo = item.codigo;
      this.descripcion = item.descripcion;
      this.id_nit = item.id_nit;
      this.editedIndex = 1;
      this.editCodigo = false;
      this.dialog = true;
    },
    addItem() {
      this.editCodigo = true;
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },

    close() {
      this.dialog = false;
      this.limpiar();
    },

    selectNits() {
      let me = this;
      axios
        .get("api/nits/select")
        .then(function (response) {
          me.nits = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    limpiar() {
      this.id = "";
      this.codigo = "";
      this.descripcion = "";
      this.id_nit = "";
      this.validaMensaje = [];
      this.editedIndex = -1;
    },
    limpiarUpload() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },

    guardar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      if (this.editedIndex > -1) {
        //codigo para editar
        let me = this;
        axios
          .put("api/servicios/actualizar", {
            id: me.id,
            codigo: me.codigo,
            descripcion: me.descripcion,
            id_nit: me.id_nit,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        //codigo para guardar
        let me = this;
        axios
          .post("api/servicios/crear", {
            codigo: me.codigo,
            descripcion: me.descripcion,
            id_nit: me.id_nit,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    guardarNit() {
      if (this.validarNit() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      } 
      let me = this;

      const formData = new FormData();
     
          formData.append("codigo", me.codigoNit);
          formData.append("descripcion", me.descripcionNit);
          formData.append("notas", me.notasNit);
          formData.append("primer_nombre", me.primer_nombreNit);
          formData.append("segundo_nombre", me.segundo_nombreNit);
          formData.append("primer_apellido", me.primer_apellidoNit);
          formData.append("segundo_apellido", me.segundo_apellidoNit);
          formData.append("direccion", me.direccionNit);
          formData.append("correo", me.correoNit);
          formData.append("telefono", me.telefonoNit);
          formData.append("celular", me.celularNit);
          formData.append("usuario", me.usuario);
        

     
      axios
      .post("api/nits/crear", formData)
          .then(function (response) {
        
          me.closeNit();
          me.limpiarNit();
          me.selectNits();
          
          me.$store.dispatch("setSnackbar", {
            text: "Nit creado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    validar() {
      this.valida = 0;

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    validarNit() {
      this.validaNit = 0;
      var i = 0;
      Object.keys(this.formNit).forEach((f) => {
        i += 1;
        console.log(i);
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.validaNit += 0;
        } else {
          this.validaNit += 1;
        }
      });
      return this.valida;
    },

    activar(item) {
      let me = this;
      axios
        .put("api/servicios/activar/" + item.id, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: " Registro activado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    desactivar(item) {
      let me = this;
      axios
        .put("api/servicios/desactivar/" + item.id, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: "Registro desactivado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    filtroCodigo(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchCodigoValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.searchCodigoValue.toLowerCase());
    },
    filtroDescripcion(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchDescripcionValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value
        .toLowerCase()
        .includes(this.searchDescripcionValue.toLowerCase());
    },
  },
};
</script>
